module.exports = __webpack_public_path__ + "static/home-illustration-tablet-a667f12f0a8e51f844911245738e41c9.png";